export default __webpack_public_path__ + "static/media/createPostSample.8da40085.png";